module.exports = require("@gauzy/config");